export const getProReviewsPath = () => `/api/v1/users/current/comments/`
export const getClientReviewsPath = (proID) => `/api/v1/users/${proID}/comments/`
export const getCreateProReplyPath = () => `/api/v1/users/current/replies/`
export const getUpdateProReplyPath = (replyID) => `/api/v1/users/current/replies/${replyID}/`